import React from 'react';
import './footer.css'

function Footer() {
    return (
        <footer className={'text-center my-8 flex flex-col'}>
            <div className={'mb-4'}>
                <a href={'https://twitter.com/hisayasahi'}>
                    <i className="fa-brands fa-twitter mx-4 fa-2x icon__twitter" />
                </a>
                <a href={'https://www.youtube.com/channel/UClzEn0mClJl4emFmRWc6G3w'}>
                    <i className="fab fa-youtube mx-4 fa-2x icon__youtube" />
                </a>
            </div>
            <div>&copy; 陽射矢　夜叉非</div>
        </footer>
    );
}

export default Footer;